// extracted by mini-css-extract-plugin
module.exports = {"DinamicBotonera":"DinamicBotonera_DinamicBotonera__15PAP","next":"DinamicBotonera_next__3FEgb","common":"DinamicBotonera_common__10axd"};